import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useMapState } from '@comp/mapbox'
import { IconButton } from '@comp/material'
import { useCallback, useEffect, useState } from 'react'
import { useMap } from 'react-map-gl'
import { houseSearchType } from '@lib/config'
import { uniqueKey } from './lib'

// 地图上的点的颜色
const colors = {
  property: 'bg-primary',
  estimate: 'bg-success',
  rental: 'bg-warning',
  sold: 'bg-error',
  rural: 'bg-[#6e7386]',
  commercialForSale: 'bg-[#855628]',
  commercialForLease: 'bg-[#2351a6]',
  stateHouse: 'bg-[#720884]',
  facility: 'bg-white',
}

function getTooltip(type, item) {
  const target = item?.points?.[0] || {}
  if(type === houseSearchType.sold) {
    return target.sold_price || target.avm_label
  }
  if(type === houseSearchType.estimate || type === 'stateHouse') {
    return target.avm
  }

  return target.price_label || target.avm_label
}

/**
 * 圆圈Marker
 */
export function MarkerDot({
  type = '',
  item = {},
  count = 0
}) {
  const { current: mapbox } = useMap()
  const { viewedMarkers } = useMapState()
  const [zoom, setZoom] = useState(mapbox.getZoom())
  const isBig = count > 1
  const isFacility = type === 'facility'
  const tooltip = getTooltip(type, item)
  const bgcolor = viewedMarkers.indexOf(item?.[uniqueKey]) > -1 
    ? 'bg-gray-500' 
    : colors[type]

  const handleZoom = useCallback(() => {
    setZoom(mapbox.getZoom())
  }, [mapbox])

  useEffect(() => {
    mapbox.on('zoomend', handleZoom)
    return () => mapbox.off('zoomend', handleZoom)
  }, [handleZoom, mapbox])
  
  return (
    <IconButton 
      className="group animate-fade-scale-in relative"
      aria-label={item.name}
    >
      <div 
        className={clsx([
          'transition-all rounded-full flex items-center justify-center text-f.6',
          'text-white group-hover:shadow-md border border-white border-solid border-2',
          !isBig && 'w-3 h-3 group-hover:w-4 group-hover:h-4',
          (isBig || isFacility) && 'w-5 h-5 group-hover:w-6 group-hover:h-6',
          bgcolor
        ])}
      >
        {!isFacility && isBig && <span>{count}</span>}
        {isFacility && (
          <img 
            src={item.icon} 
            width={14} 
            height={14} 
            alt={item.name}
          />
        )}
        {zoom > 15 && tooltip && !isBig && (
          <div 
            className={clsx([
              'absolute bottom-full text-white whitespace-nowrap px-1',
              'rounded-full text-f.6 shadow-sm -mb-1 opacity-80',
              'group-hover:opacity-100 group-hover:shadow-simple',
              bgcolor
            ])}
          >
            {tooltip}
            <span 
              className={clsx([
                'w-1 h-1 -mt-0.5 rotate-45 absolute top-full left-1/2 -translate-x-1/2', 
                bgcolor
              ])} 
            />
          </div>
        )}
      </div>
    </IconButton>
  )
}

MarkerDot.propTypes = {
  type: PropTypes.string,
  item: PropTypes.object,
  count: PropTypes.number,
}
